<template>
  <div class="history">
    <div
        class="history__years"
        role="tablist"
        :aria-activedescendant="currentYear"
        @keydown="handleKeyDown"
        ref="tabsWrapper"
    >
      <button
          v-for="year in years"
          :class="[{'_current': year === currentYear}]"
          @click="currentYear = year"
          tabindex="0"
          :aria-label="`${year} год`"
          role="tab"
          :aria-selected="year === currentYear"
          :key="year"
      >
        <span>{{ year }}</span>
      </button>
    </div>
    <div class="history__content" :key="`history${currentYear}`" role="region" aria-live="polite">
      <div class="history__text" v-html="currentText"></div>
      <div class="history__image">
        <img v-if="currentImage" :src="require(`@/assets/img/history/${currentImage}`)" alt=""/>
      </div>
    </div>
  </div>
</template>
<script>

import historyData from  "../assets/data/history.json"

export default {
  name: "HistoryBlock",
  data() {
    return {
      dataArray: historyData,
      currentYear: undefined,
      years: undefined,
      currentText: '',
      currentImage: undefined,
      activeYearId: 0
    }
  },
  watch: {
    currentYear() {
      let filteredByYear = this.dataArray.filter(obj => {
        return obj.year === this.currentYear;
      })
      this.currentText = filteredByYear[0].text;
      this.currentImage = filteredByYear[0].image
    },
  },
  mounted() {
    this.years = this.dataArray.map(obj => {
      return obj.year;
    })
    this.currentYear = this.years[0];
    const tabsWrapper = this.$refs.targetElement;
    if (tabsWrapper) {
      tabsWrapper.addEventListener('keydown', this.handleKeyDown);
    }
  },
  beforeUnmount() {
    const tabsWrapper = this.$refs.targetElement;
    tabsWrapper.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        const focusedElement = document.activeElement;
        const nextElement = event.key === 'ArrowRight' ? focusedElement.nextElementSibling : focusedElement.previousElementSibling;
        if (nextElement) {
          nextElement.focus();
        }
      }
    },
  }
};
</script>
